import { render } from "./offerBatchOpera.vue?vue&type=template&id=8a2e7e48&scoped=true"
import script from "./offerBatchOpera.vue?vue&type=script&lang=js"
export * from "./offerBatchOpera.vue?vue&type=script&lang=js"

import "./offerBatchOpera.vue?vue&type=style&index=0&id=8a2e7e48&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a2e7e48"]])

export default __exports__